<template>
  <div>
      <v-toolbar style="color: #5eca33; background-color: #2562af;" fixed dark>
        <v-toolbar-items  class="borderXwidth">
          <v-btn class="fontset" flat @click="toPage('/homepage')" >
            <!-- <v-icon style="font-size: 23px !important; color: white !important;">home</v-icon> -->
            <v-avatar tile size="43">
              <img src="/static/img/homepage/icon/home.png" />
            </v-avatar>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>

        <v-toolbar-items class="borderXwidth">
          <v-btn class="fontset text-transform" @click="toPage('/register')" flat v-if="(status_login == null || status_login == 'F')">{{$t('Register.Button.register')}}</v-btn>
          <v-btn class="fontset text-transform" @click="toLogin()" round style="height:35px; color:#2562B0;" color="white" v-if="(status_login == null || status_login == 'F')">{{$t('Login.Button.loginnavbar')}}</v-btn>
          <!-- <v-btn class="fontset" @click="toPage('/login')" round style="height:35px; color:#2562B0;" color="white" v-if="(status_login == null || status_login == 'F')">ลงชื่อเข้าใช้ นน</v-btn> -->
          <v-btn class="fontset"  @click="toPage('/chat')" flat v-else>
            <v-avatar size="50px"   style="margin-right: 1vw !important;">
              <v-img alt="profile picture" :src="profilepicture_default()" class="alligator-turtle" style="cursor: pointer;"/>
            </v-avatar>
            <p class="textlayoutnavbar">{{name}}</p>
          </v-btn>

            <v-btn flat icon row wrap @click="logout()" v-if="status_login == 'T'" style="margin-top: 11px !important;">
              <v-icon style="font-size: 25px !important;">mdi-logout-variant</v-icon>
            </v-btn>
            <v-menu offset-y style="z-index: 11;">
              <img v-if="$i18n.locale == 'th'" slot="activator" src='/static/flag/thailand.svg' class="iconLanguage"></img>
              <img v-else-if="$i18n.locale == 'en'" slot="activator" src='/static/flag/united-kingdom.svg' class="iconLanguage"></img>
              <img v-else-if="$i18n.locale == 'cn'" slot="activator" src='/static/flag/china.png' class="iconLanguage"></img>
              <v-list>
                <v-list-tile @click="changeLan('th')">
                  <v-list-tile-title>
                    <img src='/static/flag/thailand.svg' style="height: 20px;"/>&nbsp;&nbsp;ไทย
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="changeLan('en')">
                  <v-list-tile-title>
                    <img src='/static/flag/united-kingdom.svg' style="height: 20px;"/>&nbsp;&nbsp;ENG
                  </v-list-tile-title>
                </v-list-tile>
                <!-- <v-list-tile @click="changeLan('cn')">
                  <v-list-tile-title>
                    <img src='/static/flag/china.png' style="height: 20px;"/>&nbsp;&nbsp;简体中文
                  </v-list-tile-title>
                </v-list-tile> -->
              </v-list>
            </v-menu>
        </v-toolbar-items>
      </v-toolbar>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
export default {
  data () {
    return {
      name: '',
      profilepicture: '',
      typeuser: '',
      status_login: 'F',
      pathname: ''
    }
  },
  methods: {
    changeLan (lang) {
      this.$i18n.locale = lang
      this.$cookie.set('language', lang)
      // this.changeLangMenu()
    },
    toPage (page) {
      // console.log(page)
      this.pathname = page
      this.$router.push(page)
    },
    profilepicture_default () {
      if (this.profilepicture) {
        return this.profilepicture
      } else if (this.typeuser === 'government' || this.typeuser === 'company') {
        return '/static/img/default_profile/business-white.png'
      } else {
        return '/static/img/default_profile/man-white.png'
      }
    },
    logout () {
      localStorage.clear()
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl')
      if (process.env.LogoutOneid) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          window.open(process.env.LogoutOneid, '_parent')
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          this.$router.push({path: '/login', force: true})
        }
      }
    },
    toLogin() {
      if(localStorage.tologin){
        localStorage.removeItem("tologin")
      }
      this.$router.push('/login')
    }
  },
  computed: {
    ...sync('*')
  },
  watch: {
    myname () {
      this.name = localStorage.getItem('name')
    },
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    }
  },
  created () {
    this.pathname = location.pathname
    // console.log(this.pathname)
    // this.status_login = this.$cookie.get("status_login")
    // console.log(localStorage.getItem('Authenrization'))
    if (localStorage.getItem('Authenrization')) {
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.status_login = decoded['status_login']
    }
    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // this.status_login = decoded['status_login']
    this.name = localStorage.getItem('name')
    this.profilepicture = localStorage.getItem('profilepicture')
    this.typeuser = localStorage.getItem('type_user')
    if (this.$router.currentRoute.path === '/' && this.status_login === 'T') {
      this.$router.push('/chat')
    }
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    // this.$i18n.locale = 'th'
  }
}
</script>

<style lang="css" scoped>
.text-transform {
  text-transform: none !important;
}
.iconLanguage {
  height: 25px;
  cursor: pointer;
  /* margin-top: 17px; */
  margin-left: 20px;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
div.borderXwidth a:before, div.borderXwidth a:after
{
    position: absolute;
    opacity: 0;
    width: 0%;
    height: 2px;
    content: '';
    background: gray;
    transition: all 0.3s;
}

div.borderXwidth a:before
{
    left: 0px;
    top: 0px;
}

div.borderXwidth a:after
{
    right: 0px;
    bottom: 0px;
}

div.borderXwidth a:hover:before, div.borderXwidth a:hover:after
{
    opacity: 1;
    width: 100%;
}
.fontset{
  font-weight: bold !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:17px !important;
  /*font-weight: 900px;*/
}

.btn .btn__content .icon {
    color: inherit;
    font-size: 11px !important;
}
/*.carousel__controls {
  height: 24px;
}*/
.textlayoutnavbar {
  white-space: nowrap;
  width: 5em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 0vw !important;
  font-family: 'CS ChatThaiUI', sans-serif !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Navbar.vue